import { useState } from 'react'
import { submitChangePassword } from '../api/passwordChange'
import { apiRequest } from '../utils/apiRequest'

export function useChangePassword() {
  const [state, setState] = useState({
    errorCode: '',
    processed: false,
    disabledForm: false,
  })

  const submit = async ({ oldPassword, password }) => {
    setState((s) => ({ ...s, disabledForm: true }))
    try {
      await apiRequest(submitChangePassword, {
        old_password: oldPassword,
        new_password: password,
      })
      setState((s) => ({
        ...s,
        processed: true,
        errorCode: '',
        disabledForm: false,
      }))
    } catch (error) {
      setState((s) => ({ ...s, errorCode: error.message, disabledForm: false }))
    }
  }

  return { ...state, submit }
}
